import React, { Component } from 'react';
import {Alert} from "reactstrap";
import {Provider} from 'react-redux';
import {createStore} from 'redux';
import reducers from './redurcers'
import LoadingModal from "./components/loadingModal/loadingModal";
import NavBarComponent from "./components/navBar/navBarComponent";
import FontAwesome from 'react-fontawesome';
import './App.css';
import {getAlertState, getSessionState} from "./actions";

//create state store app
export const store = createStore(reducers);

class App extends Component {
    constructor() {
        super();
        this.state = {
            showLoading:false,
            alert: {visible: false, icon: "", text: "", alertType: ""},
        }

        store.subscribe(() => {
            this.setState({showLoading:getSessionState().showLoading});
            this.setState({alert:getAlertState().alert});
        });
    }

  render() {
    return (
        <Provider store={store}>
            <div>
                <NavBarComponent />
                <Alert color={this.state.alert.alertType} className="margin-alert" isOpen={this.state.alert.visible} >
                    <FontAwesome name={this.state.alert.icon}/> {this.state.alert.text}
                </Alert>
                <LoadingModal visible={getSessionState().showLoading}/>
                {this.props.children}
            </div>
        </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js